import React, { Component } from 'react';
import { PtInput, PtSelect, PtInputAndEstimate } from '../../../../grit-utilities';
import DropdownLib from '../../../../DropdownLib';
import MaintenanceTemplate from './maintenance-template';

export default class Regravel extends Component {

    constructor(props) {
        super(props);

        const { csModel } = this.props;

        this.state = csModel.maintenance;
        //console.log(csModel);

        //this.state.selectedIndex = 0;
    }

    componentWillMount() {
        this.setState({
            selectedIndex: 0
        });
    }
    
    render() {
        return (
            <MaintenanceTemplate dataModel={this.state.regravel}
                selectedIndex={this.state.selectedIndex}
                name="Re-Gravel"

                updateSelectedIndex={(index) => this.setState({ selectedIndex: index })}
                updateDataModel={(tempArray) => this.setState({ regravel: tempArray })}

                templadeData={{
                    year: "0",
                    timesPerYear: 0,
                    costPerMile: 0.0,
                    gravelType: 0,
                    completedBy: 0,
                    yearEst: 0
                }}

                triggerNeedSave={this.props.triggerNeedSave}
                deleteRecord={(tempArray) => this.setState({ selectedIndex: 0, regravel: tempArray })}
                addRecord={(index, tempArray) => this.setState({ selectedIndex: index, regravel: tempArray })}
                disabled={this.props.disabled}

                renderMaintenance={this.renderMaintenance}
            />
        );
    }
    // renderMaintenance needs all of these or you will run into issues of crashing.
    renderMaintenance = (onChangeIndex, onChangeDropdown, onChangeDropdownEstimated, onInputChange, onChangeDate ) => {

        const { gravelType } = DropdownLib.getDropdowns().CSM_ReGravel;

        const { completedByOptions } = DropdownLib.getDropdowns().CS_SurfaceTreatment;

        const selected = this.state.selectedIndex;

        return (
            <div>
                {/* regravel */}
                <PtInputAndEstimate label="Year"
                    inputType="year"
                    placeholder="1990"
                    name="year"
                    estimated={this.state.regravel[selected].yearEst}
                    value={this.state.regravel[selected].year}
                    onChange={onInputChange}
                    disabled={this.props.disabled} />

                <PtInput label="Cost Per Mile"
                    name="costPerMile"
                    inputType="number"
                    placeholder="0"
                    value={this.state.regravel[selected].costPerMile}
                    onChange={onInputChange}
                    disabled={this.props.disabled} />

                <PtInput label="Times per Year"
                    name="timesPerYear"
                    inputType="number"
                    placeholder="0"
                    value={this.state.regravel[selected].timesPerYear}
                    onChange={onInputChange}
                    disabled={this.props.disabled} />

                <PtSelect label="Gravel Type"
                    options={gravelType}
                    name="gravelType"
                    defaultVal={this.state.regravel[selected].gravelType}
                    onChange={onChangeDropdown}
                    disabled={this.props.disabled} />

                <PtSelect label="Completed By"
                    options={completedByOptions}
                    name="completedBy"
                    defaultVal={this.state.regravel[selected].completedBy}
                    onChange={onChangeDropdown}
                    disabled={this.props.disabled} />
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/layers/tabs/cons-segment/maintenance/regravel.js